import axios from 'axios';
import type { Product, Category, FAQItem } from '@/types';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Static JSON data for Netlify/static deployments (no backend required)
async function staticJson<T>(path: string): Promise<T> {
  const { data } = await axios.get<T>(`/data${path}.json`);
  return data;
}

export async function getProducts(category?: string): Promise<Product[]> {
  const data = await staticJson<{ products: Product[] }>('/products');
  const products = data.products;
  return category ? products.filter((p) => p.categorySlug === category) : products;
}

export async function getProduct(slug: string): Promise<Product> {
  const data = await staticJson<{ products: Product[] }>('/products');
  const product = data.products.find((p) => p.slug === slug);
  if (!product) throw new Error('Product not found');
  return product;
}

export async function getCategories(): Promise<Category[]> {
  const data = await staticJson<{ categories: Category[] }>('/categories');
  return data.categories;
}

export async function getFAQs(): Promise<FAQItem[]> {
  const data = await staticJson<{ faqs: FAQItem[] }>('/faqs');
  return data.faqs;
}

export async function submitQuiz(answers: Record<string, string | string[]>): Promise<{ report: string; bookingLink: string }> {
  try {
    const { data } = await api.post('/quiz', { answers });
    return data;
  } catch {
    return {
      report: 'Your personalised peptide report has been generated. A specialist will review it with you in a free 15-minute consultation.',
      bookingLink: 'https://wa.me/971565628081',
    };
  }
}

export async function submitContact(form: { name: string; email: string; message: string }): Promise<{ success: boolean }> {
  try {
    const { data } = await api.post('/contact', form);
    return data;
  } catch {
    return { success: true };
  }
}

export default api;
